import { ApplicationId } from "@1games-ru/region-shared/dist/enums/phone/application-id";
import { DateInfo } from "@/core/constants/dateInfo";
import { imgPhoneBgUnlock } from "@/shared/assets/img";
import { PhoneSystemAppsListEnum } from "@/domains/phone/constants/phoneSystemAppsListEnum";
import { applicationsInfo } from "@/domains/phone/helpers/applicationsInfo";
import { phoneSystemAppsList } from "@/domains/phone/helpers/phoneSystemAppsList";
import PhoneHeader from "@/domains/phone/components/PhoneHeader";
import PhoneSystemAppIcon from "@/domains/phone/components/PhoneSystemAppIcon";

type Props = {
  appsList: ApplicationId[];
  currentTime: DateInfo;
  changeActiveApp: (appId: ApplicationId) => void;
  changeSystemActiveApp: (appId: PhoneSystemAppsListEnum) => void;
  handleIconClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function PhoneHomeScreen({
  appsList,
  currentTime,
  changeActiveApp,
  changeSystemActiveApp,
  handleIconClick,
}: Props) {
  const { hours, minutes } = currentTime;

  const handleAppIcon = (event: React.MouseEvent<HTMLElement>, item: ApplicationId) => {
    changeActiveApp(item);
    handleIconClick(event);
  };

  const handleSystemAppIcon = (
    event: React.MouseEvent<HTMLElement>,
    item: PhoneSystemAppsListEnum,
  ) => {
    changeSystemActiveApp(item);
    handleIconClick(event);
  };

  return (
    <div
      className="flex flex-wrap size-full bg-no-repeat bg-cover"
      style={{
        backgroundImage: `url(${imgPhoneBgUnlock})`,
      }}
    >
      <div className="w-full">
        <PhoneHeader hours={hours} minutes={minutes} />
        <div className="grid grid-cols-4 gap-4 w-full px-5">
          {appsList.map((item) => (
            <button
              key={applicationsInfo[item]?.name}
              className="flex flex-col items-center"
              onClick={(event) => handleAppIcon(event, item)}
              type="button"
            >
              <div
                className="size-15 mb-1.5 rounded-[1.25rem] bg-white bg-contain"
                style={{
                  backgroundImage:
                    applicationsInfo[item]?.icon && `url(${applicationsInfo[item]?.icon})`,
                }}
              />
              <p className="text-14 font-medium text-center">{applicationsInfo[item]?.name}</p>
            </button>
          ))}
        </div>
      </div>
      <div className="mt-auto mb-3.5 mx-auto">
        <div className="flex justify-center gap-2.5 mb-5">
          <div className="w-2 h-2 bg-white rounded-xl" />
          <div className="w-2 h-2 bg-white/50 rounded-xl" />
          <div className="w-2 h-2 bg-white/50 rounded-xl" />
        </div>
        <div className="flex justify-center gap-4 p-2.5 rounded-[1.75rem] bg-dark-800/40">
          {phoneSystemAppsList.map((item, idx) => (
            <PhoneSystemAppIcon
              key={item.id}
              id={idx}
              Icon={item.icon}
              background={item.background}
              onClick={handleSystemAppIcon}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
